export enum ACTION_TYPES {
  PERSIST_APPLICATION_DATA_COLLECTION = 'PERSIST_APPLICATION_DATA_COLLECTION',
  PERSIST_APPLICATION_DATA_COLLECTION_SUCCESS = 'PERSIST_APPLICATION_DATA_COLLECTION_SUCCESS',
  PERSIST_APPLICATION_DATA_COLLECTION_FAILED = 'PERSIST_APPLICATION_DATA_COLLECTION_FAILED',
}
